module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/009-2180d2f60074085d69091647d0556ae8.jpg";